export const MENU_WIDTH = 251;
